import AudioValidado from "../../constructor/umas/Actividades/ActividadesUtils/RecursosValidados/AudioValidado";
import PlaceholderMedia from "../../constructor/umas/PlaceholderMedia";

export default function Audio({ audio, pieDeFoto, isGeneratingPDF = false }) {
  const reemplazarRecursos = new URLSearchParams(window.location.search).get('reemplazarRecursos') === 'true';

  // En modo PDF, mostrar placeholder
  if (isGeneratingPDF && audio && audio.includes(".mp3")) {
    return (
      <div className="my-4 md:my-8 w-full">
        <PlaceholderMedia 
          tipo="audio" 
          nombreArchivo={reemplazarRecursos ? audio : null} 
        />
        {pieDeFoto && pieDeFoto !== "" && (
          <div
            className="w-full mt-2 p-1"
            dangerouslySetInnerHTML={{ __html: pieDeFoto }}
          ></div>
        )}
      </div>
    );
  }

  return (
    <>
      {audio && audio.includes(".mp3") && (
        <div className="my-4 md:my-8 w-full">
          <div className="w-full flex justify-center">
            <AudioValidado src={audio} className="w-full" />
          </div>
          {pieDeFoto && pieDeFoto !== "" && (
            <div
              className="w-full mt-2 p-1"
              dangerouslySetInnerHTML={{ __html: pieDeFoto }}
            ></div>
          )}
        </div>
      )}
    </>
  );
}
